import { DtoBase, ObjectStateEnum } from '../../../shared/model/index';

export class EventItemCreditType extends DtoBase {
  public EventPriceCreditTypeId: number = 0;
  public CreditTypeId: number = 0;
  public EventItemId: number = 0;
  public Credits: number = 0;
  public CreditType: string = '';
}
